export const MINIMUM_WIDTH = 30
export const ROW_HEIGHT = 42
export const SHEET_HEADER_CELL_HEIGHT = 48
export const HEADER_ICON_GRID_GAP = 2
export const HEADER_CELL_HORIZONTAL_PADDING = 4
export const CELL_BODY_PADDING_LEFT = 4
